import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import config from 'app-config';
import { initialMemberPrivateState } from '../constants';

export const REDUCER_NAME = 'app';

const initialState = {
  isLoading: true,
  isLoaded: false,
  profile: {},
  userSettings: {},
  displayMode: 'browser',
  isLabelExpanded: !!Number(window.localStorage.getItem('isLabelExpanded', 0)),
  showInstallPrompt: null,
  showInstallPromptModal: null,
  chronosApiUrl: config.chronosApiUrl,
  trelloApiKey: config.trelloApiKey,
  trelloToken: null,
  theme: 'light',
};

export const fetchUserSettings = createAsyncThunk(
  `${REDUCER_NAME}/fetchUserSettings`,
  () =>
    Promise.resolve({
      ...initialMemberPrivateState.userSettings,
      showStartReview: false,
      showStopReview: true,
    })
);

export const appSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setLoaded: (state, action) => {
      state.isLoaded = action.payload;
    },
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
    setDisplayMode: (state, action) => {
      state.displayMode = action.payload;
    },
    setLabelExpanded: (state, action) => {
      state.isLabelExpanded = action.payload;
    },
    setShowInstallPrompt: (state, action) => {
      state.showInstallPrompt = action.payload;
    },
    setShowInstallPromptModal: (state, action) => {
      state.showInstallPromptModal = action.payload;
    },
    setTrelloToken: (state, action) => {
      state.trelloToken = action.payload || null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserSettings.fulfilled, (state, action) => {
      state.userSettings = action.payload;
    });
  },
});

const selectSelf = (state) => state[REDUCER_NAME];
export const selectTheme = (state) => selectSelf(state).theme;
export const selectProfile = (state) => selectSelf(state).profile;
export const selectUserSettings = (state) => selectSelf(state).userSettings;
export const selectIsLoading = (state) => selectSelf(state).isLoading;
export const selectIsLoaded = (state) => selectSelf(state).isLoaded;
export const selectIsLabelExpanded = (state) =>
  selectSelf(state).isLabelExpanded;
export const selectDisplayMode = (state) => selectSelf(state).displayMode;
export const selectShowInstallPrompt = (state) =>
  selectSelf(state).showInstallPrompt;
export const selectShowInstallPromptModal = (state) =>
  selectSelf(state).showInstallPromptModal;

export const mapState = (state) => ({
  isLoading: selectIsLoading(state),
  isLoaded: selectIsLoaded(state),
  profile: selectProfile(state),
  isLabelExpanded: selectIsLabelExpanded(state),
  showInstallPrompt: selectShowInstallPrompt(state),
});

export const { actions, reducer } = appSlice;

export const {
  setLoading,
  setProfile,
  setDisplayMode,
  setLabelExpanded,
  setShowInstallPrompt,
  setShowInstallPromptModal,
  setTrelloToken,
  setTheme,
} = actions;

export default reducer;
